import { render, staticRenderFns } from "./FensiManage.vue?vue&type=template&id=192cd39e&scoped=true"
import script from "./FensiManage.vue?vue&type=script&lang=js"
export * from "./FensiManage.vue?vue&type=script&lang=js"
import style0 from "./FensiManage.vue?vue&type=style&index=0&id=192cd39e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192cd39e",
  null
  
)

export default component.exports